/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BookingHistoryDto } from '../../models/booking-history-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetBookingApprovalsHistory$Params {
  recourseBookingId: number;
}

export function getBookingApprovalsHistory(
  http: HttpClient,
  rootUrl: string,
  params: GetBookingApprovalsHistory$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<BookingHistoryDto>>> {
  const rb = new RequestBuilder(rootUrl, getBookingApprovalsHistory.PATH, 'get');
  if (params) {
    rb.path('recourseBookingId', params.recourseBookingId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BookingHistoryDto>>;
    }),
  );
}

getBookingApprovalsHistory.PATH = '/service/v1/bookingapprovals/history/{recourseBookingId}';
